import { useState, useMemo } from "react";
import { Button } from "@aidron/aidron-ds";
import { ModalTemplate } from "../../SharedComponents/sharedComponents.index";
import { CustomText } from "../../StyledComponents/styleComponents.index";
import PropTypes from 'prop-types';

export function ArrowModalButton({ label, renderModalContent, size }) {
  const [showModal, setShowModal] = useState(false);

  const onCloseModal = () => setShowModal(false);

  const modalContent = useMemo(
    () => renderModalContent({ closeModal: onCloseModal }),
    [renderModalContent]
  );

  return (
    <>
      <section style={{ display: 'flex', flexDirection: 'column', marginInlineStart: '1.5rem' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <CustomText fontSize={['0.4rem', '0.7rem', '1.1rem']} weight="bold" margin="0 0.5rem 0 0">
            {label}
          </CustomText>
          <Button label="" onClick={() => setShowModal(true)} icon="arrow-up-right" type="outlined" size={size ? size : "sm"} />
        </div>
      </section>
      
      <ModalTemplate open={showModal} width="900px" heading={label} closingFunction={onCloseModal}>
        {modalContent}
      </ModalTemplate>

    </>
  );
};

ArrowModalButton.propTypes = {
  label: PropTypes.string,
  renderModalContent: PropTypes.func,
  size: PropTypes.string
}